<!-- 企业认证 -->
<template>
  <div class="wrapper">
    <div v-if="state == 1">
      <!-- <el-card>
        <div class="header">
          <el-steps :active="active" align-center>
            <el-step title="企业信息" :icon="active > 1 ? 'el-icon-circle-check' : ''"></el-step>
            <el-step title="开户许可证" :icon="active > 2 ? 'el-icon-circle-check' : ''"></el-step>
          </el-steps>
        </div>
      </el-card> -->
      <div v-if="active == 1">
        <enterprise-information @jumpStep="jumpStep"></enterprise-information>
      </div>
      <!-- <div v-if="active == 2">
        <accountOpeningPermit @jumpStep="jumpStep"></accountOpeningPermit>
      </div> -->
    </div>
    <div v-if="state == 2">
      <authentication @jumpStep="jumpStep"></authentication>
    </div>
  </div>
</template>
<script>
import enterpriseInformation from "./enterpriseInformation.vue";
import accountOpeningPermit from "./accountOpeningPermit.vue";
import authentication from "./authentication.vue";
import { mapActions } from "vuex";
export default {
  components: {
    enterpriseInformation, accountOpeningPermit, authentication
  },
  data() {
    return {
      active: 1,
      state: 1
    }
  },
  mounted() {
    this.queryByCustomerNo();
  },
  methods: {
    ...mapActions([
      "queryByCustomerNoAPI",
    ]),
    jumpStep(type) {
      if (type) {//1.企业信息 2.开户许可证 3.提交审核 4.修改企业信息
        if (type == 3) {
          this.state = 2;
        } else if (type == 4) {
          this.active = 1; this.state = 1;
        } else {
          this.active = type;
        }
      }
    },
    // 状态，0：未提交审核 1：提交资料，2-审核通过，3-审核驳回，4-失效，5-sap申请中, 6-个人实名认证-未完成， 7-个人实名认证-已完成，注：当status=0,1,2,3,4,5是否，实名认证是已经开通的，如果status=6，7时候，企业实名认证未开通
    queryByCustomerNo() {
      // 进入页面回显相关信息
      let params = {
        customerNo: JSON.parse(sessionStorage.getItem("userInfo")).customerNo,
      };
      this.queryByCustomerNoAPI(params).then((res) => {
        let { customerDetail, historyList } = res;
        this.status = customerDetail.status;
        this.customerDetail = customerDetail;
        if (this.status == 6 || this.status == 7) {
          this.active = 1; this.state = 1;
        } else {
          this.state = 2;
        }
      });
    },
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-step__title.is-finish {
  color: #000;
  font-weight: 700;
}
/deep/ .el-step__title.is-process {
  color: #c0c4cc;
  font-weight: 700;
}
.header {
  padding: 24px 0 !important;
}
</style>